import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/** Bölüm boş (büyük biçim, ui.md §12.8). Hücre ya da kart boşsa yalnız cümle yazılır, bu bileşen kullanılmaz. */
export function EmptyState({ icon: Icon, title, children }: { icon: LucideIcon; title: string; children?: ReactNode }) {
  return (
    <div data-slot="empty-state" className="flex flex-col items-center gap-1 py-10 text-center">
      <span aria-hidden="true" className="mb-2 flex size-10 items-center justify-center rounded-full bg-muted"><Icon className="size-5 text-muted-foreground" /></span>
      <p className="text-sm font-medium">{title}</p>
      {children && <div className="text-sm text-muted-foreground">{children}</div>}
    </div>
  );
}
